import math from 'react-xocs/dist/math';
import { createCompose, skip } from 'react-xocs/dist/xocs/xocs-core';
import para from 'react-xocs/dist/xocs/para';
import XocsType from '../xocsType';

const xocs = {
  caption: skip,
  'cross-ref': skip,
  'simple-para': para,
  math,
};

const captionText = createCompose(xocs);

const Caption = ({ content }) => captionText(content);

Caption.propTypes = {
  content: XocsType.isRequired,
};

export default Caption;
